/**
 * Yandex Maps link that builds a route to the studio from wherever the visitor is
 * (an empty start point means "my location"). On a phone it opens the Yandex Maps
 * or Navigator app when installed. The address is resolved by Yandex itself.
 */
export function yandexRouteUrl(address: string): string {
  return `https://yandex.ru/maps/?rtext=${encodeURIComponent(`~${address}`)}&rtt=auto`;
}
